export let jurpsi_1_11 = {
	"name": "jurpsi_1_11",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое мышление?",
				"correct_ans": [
					{
						"ans": "Сложный психический процесс, отражения действительности, высшая форма творческой активности человека по отражению окружающей действительности, в ее существенных признаках, разнообразии и связях между объектами",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Эмоции, влечения, мотивы к действию, возникающие у человека вопреки его желанию",
						"score": 0
					},
					{
						"ans": "Приобретенное в результате обучения и тренинга умение решать задачи в сфере профессиональной деятельности, оперировать орудиями труда с заданной скоростью и точностью",
						"score": 0
					},
					{
						"ans": "Сознательное решение, выполняющее функцию побуждения, моделирования поведения и целенаправленной деятельности человека",
						"score": 0
					},
					{
						"ans": "Психический процесс, совершающийся в процессе практической деятельности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_7 = {
	"name": "jurpsi_1_7",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое \"память\"? Укажите правильные варианты ответов",
				"correct_ans": [
					{
						"ans": "Отражение непосредственного или прошлого опыта человека путем фиксирования, сохранения и последующего воспроизведения ранее пережитых им чувств, мыслей, образов, прежде воспринятых предметов и явлений",
						"score": 13
					},
					{
						"ans": "Форма психического отражения действительности, заключающаяся в закреплении, сохранении и последующего воспроизведения человеком своего прошлого опыта",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"ans": "Количественный показатель сохранившегося в памяти и воспроизведенного объема информации, воспринятой человеком прежде",
						"score": 0
					},
					{
						"ans": "Нарушения, сокращение или полная утрата способности запоминать, узнавать и воспроизводить ранее воспринятую информацию",
						"score": 0
					},
					{
						"ans": "Преимущественное развитие одного из видов памяти, выделяемых в соответствии с характером и способом запоминаемого материала",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let jurpsi_1_58 = {
	"name": "jurpsi_1_58",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое исправительная (пенитециарная) психология?",
				"correct_ans": [
					{
						"ans": "Составная часть юридической психологии, изучающая психологические основы ресоциолизации личности осужденного - восстановления утраченных социальных связей и качеств личности, необходимых для нормальной жизни в обществе",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Отрасль психологической науки, изучающаяпсихические состояния осужденного к лишению свободы",
						"score": 0
					},
					{
						"ans": "Совокупность нормативных актов, регулирующих порядок исполнения уголовного наказания",
						"score": 0
					},
					{
						"ans": "Практические рекомендации по ресоциализации осужденных",
						"score": 0
					},
					{
						"ans": "Набор средств и приемов психологической коррекции личности преступника",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_29 = {
	"name": "jurpsi_1_29",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Какое определение понятия \"личность преступника\" является правильным с позиций юридической психологии?",
				"correct_ans": [
					{
						"ans": "Специфическая сущность личности преступника заключается в особенностях его психологического склада, которые выражают собой внутренние предпосылки антиобщественного полвведения",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Это особенности психологической структуры личности. Черт внешности и специфики поведения, передаваемые по наследственности и образующие стойкий социальный тип врожденного преступника",
						"score": 0
					},
					{
						"ans": "Личность преступника (преступный тип) - это сочетание устойчивых свойств, в силу которых индивид реагирует на внешние раздражители преступным поведением определенного характера",
						"score": 0
					},
					{
						"ans": "Личность преступника - это комплекс особенностей характера и взглядов человека, в силу которых выбирает преступный путь при таких обстоятельствах, при которых другие люди воздержатся от совершения преступления",
						"score": 0
					},
					{
						"ans": "Личность преступника отличается от личности законопослушного негативным содержанием ценностно-нормативной системы и устойчивым психологическими особенностям, сочетания которых имеет криминогенное значение и специфично именно для преступника",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_53 = {
	"name": "jurpsi_1_53",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Укажите психологические элементы (часть) обвинительной речи прокурора, выступающего в судебном заседании в качестве государственного обвинителя",
				"correct_ans": [
					{
						"ans": "Характеристика личности подсудимого",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Общественная оценка деяния подсудимого",
						"score": 0
					},
					{
						"ans": "Анализ и оценка собранных по делу доказательств",
						"score": 0
					},
					{
						"ans": "Меры по предупреждению преступлений",
						"score": 0
					},
					{
						"ans": "Юридическая квалификация содеянного подсудимым",
						"score": 0
					},
					{
						"ans": "Предложения о виде и размере наказания",
						"score": 0
					},
					{
						"ans": "Соображения о возмещении материально ущерба и судьбе вещественных доказательств",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_42 = {
	"name": "jurpsi_1_42",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Укажите основные общие черты психологии личности юриста",
				"correct_ans": [
					{
						"ans": "Профессиональная направленность (интерес к профессиональной деятельности, развитое правосознание и чувство социальной справедливости, приоритет законности)",
						"score": 4
					},
					{
						"ans": "Моральный облик, отвечающий нормам нравственности общества",
						"score": 4
					},
					{
						"ans": "Соблюдение норм профессиональной этики и нравственного долга перед обществом",
						"score": 5
					},
					{
						"ans": "Способность познавать психологию личности другого человека в рамках процессуальной деятельности",
						"score": 4
					},
					{
						"ans": "Ориентация на спецеффические социальные ценности - нормы законы, умение уяснить \"дух и букву\" закона в точном соответствии с волей законодателя",
						"score": 4
					},
					{
						"ans": "Разумные и целесообразное использование властных полномочий в интересах законности и правопорядка",
						"score": 4
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let jurpsi_1_10 = {
	"name": "jurpsi_1_10",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое амнезия?",
				"correct_ans": [
					{
						"ans": "Полное отсутствие памяти",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Усиление памяти",
						"score": 0
					},
					{
						"ans": "Ослабление памяти",
						"score": 0
					},
					{
						"ans": "Обманчивое запоминание",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_31 = {
	"name": "jurpsi_1_31",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое правовая социализация личности?",
				"correct_ans": [
					{
						"ans": "Усвоение критериев оценки юридически значимых ситуаций, законов, правил и норм общежития и умения пользоваться этими нормами при выборе правомерных действий",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Утверждение социального статуса личности в системе межличностных отношений",
						"score": 0
					},
					{
						"ans": "Завоевание авторитета в среде ближайшего окружения",
						"score": 0
					},
					{
						"ans": "Регулятор поведения личности, сформированный под воздействием внешних влияний по принципу обратной связи и направляющий деятельность людей в правовых ситуациях, в которых они оказываются",
						"score": 0
					},
					{
						"ans": "Выполнение функций лидерства в \"малой группе\"",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_14 = {
	"name": "jurpsi_1_14",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Что такое внимание?",
				"correct_ans": [
					{
						"ans": "Направленность и сосредоточенность психической деятельности человека при выполнении сознательной деятельности на определенных объектах, процессах и явлениях",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Избирательное повышение возбудимости мозговых структур, принимающих участие в мыслительных процессах при той или иной деятельности человека",
						"score": 0
					},
					{
						"ans": "Количество элементов окружающего мира, одновременно воспринимаемых человеком",
						"score": 0
					},
					{
						"ans": "Способы вербального и невербального эмоционально окрашенного воздействия на человека с целью создания у него определенного состояния или побуждения к определенным действиям",
						"score": 0
					},
					{
						"ans": "Индивидуальная податливость человека воздействиям окружающих людей",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_17 = {
	"name": "jurpsi_1_17",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Какое определение понятия \"чувства\" наиболее правильно?",
				"correct_ans": [
					{
						"ans": "Устойчивое эмоциональное отношение человека к явлениям действительности, отражающее значимость этих явлений в связи с потребностями человека и мотивами его деятельности",
						"score": 25
					}
				],
				"wrong_ans": [
					{
						"ans": "Способность живого организма воспринимать внешние раздражения, отвечая на них соответствующим образом",
						"score": 0
					},
					{
						"ans": "Количественное выражение признаков материальных, эстетических, социальных и иных объектов, процессов и явлений",
						"score": 0
					},
					{
						"ans": "Познавательная позиция личности, характеризуемая фиксацией на собственных целях, стремлениях и переживаниях при игнорировании других людей",
						"score": 0
					},
					{
						"ans": "Воспроизведение во всех деталях образов предметов, не воздействующих в данный момент, на анализаторы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let jurpsi_1_9 = {
	"name": "jurpsi_1_9",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "В каких формах проявляются расстройства памяти?",
				"correct_ans": [
					{
						"ans": "Амнезия",
						"score": 7
					},
					{
						"ans": "Гипермнезия",
						"score": 6
					},
					{
						"ans": "Гипомнезия",
						"score": 6
					},
					{
						"ans": "Парамнезия",
						"score": 6
					}
				],
				"wrong_ans": [
					{
						"ans": "Мю-ритм",
						"score": 0
					},
					{
						"ans": "Навязчивые состояния",
						"score": 0
					},
					{
						"ans": "Гамма-ритм",
						"score": 0
					},
					{
						"ans": "Нейропсихологические синдромы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let jurpsi_1_48 = {
	"name": "jurpsi_1_48",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Юридическая психология",
	"data": {
		"questions": [
			{
				"qst": "Укажите психологические особенности создания преступниками тайников, сокрытия похищенного или орудий преступления",
				"correct_ans": [
					{
						"ans": "Организация конфликтов с целью отвлечения внимания от нахождения тайника при обыске",
						"score": 4
					},
					{
						"ans": "Оставление искомых предметов на видном",
						"score": 4
					},
					{
						"ans": "Изготовление \"ложных тайников\"",
						"score": 5
					},
					{
						"ans": "Расчет на проявление тактичности и отказ по этим соображениям от осмотра постели младенца, тяжелобольного, могил и склепов, урн погребенных родственников",
						"score": 4
					},
					{
						"ans": "Расчет на брезгливость (тайники в выгребной яме, кучи навоза, унитазе и т.п.)",
						"score": 4
					},
					{
						"ans": "Расчет на автоматизм действий и фактор утомления производящих обыск",
						"score": 4
					}
				],
				"wrong_ans": [
					{
						"ans": "Расчет на профессиональную неопытность следователя",
						"score": 0
					},
					{
						"ans": "Расчет на \"авось\"",
						"score": 0
					},
					{
						"ans": "Расчет на то, что не будет получена санкция на обыск по месту жительства друзей, знакомых и просто посторонних людей",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

